<template>
  <div class="content">
    <div class="title">{{ $t('common.step.4') }}</div>
    <!--    {{ form }}-->
    <!--    {{ currentMassEmailObj }}-->
    <div class="box_inner">
      <el-form
          ref="ruleFormRef"
          :model="form"
          label-width="120px"
          class="demo-ruleForm"
          :rules="rules"
          :label-position="'top'"
      >
        <el-form-item :label="$t('common.step.search.2')" prop="taskName">
          <el-input
              v-model="form.taskName"
              :placeholder="$t('90201')"
              style="width: 50%"
          ></el-input>
        </el-form-item>
        <el-form-item
            v-for="(item, index) in form.subjectList"
            :key="index"
            :prop="`subjectList.${index}.content`"
            :rules="[
                { required: true, message: $t('common.email.contentCannotBeEmpty'), trigger: ['blur', 'change'] }
            ]"
            :label="index === 0 ? $t('sending.table.col.title') : ''"
        >
          <template #default>
            <el-input
                v-model="form.subjectList[index].content"
                class="add_inputs"
                :placeholder="$t('common.subject.form')"
                style="width: 50%"
                show-word-limit
                maxlength="300"
            ></el-input>
            <div
                class="setting_box"
                v-if="true"
            >
              <el-button
                  style="margin-left: 0px !important;"
                  @click="removeSubject(index,form.subjectList[index].content)"
                  type="danger"
                  link
                  v-if="form.subjectList.length!==1"
              >
                {{ $t('common.delete') }}
              </el-button>
              <div class="add_button" v-if="index===0">
                <el-button v-if="!(form.subjectList.length>4)" size="small" @click="addSubject" type="primary"
                           :icon="Plus"
                           text>{{
                    $t('common.add')
                  }}
                </el-button>
              </div>
            </div>
            <div v-else class="setting_box"></div>
          </template>
        </el-form-item>
        <el-form-item :label="$t('common.send.email.box')" prop="mailMassConfigDtoList">
          <el-select
              v-model="form.mailMassConfigDtoList"
              class="mailselectEl"
              multiple
              remote
              :placeholder="$t('common.please.input')"
              style="width: 50%"
              :value-key="'configId'"
          >
            <el-option
                v-for="item in userMail_dropDownOptionList"
                :key="item.configId"
                :label="item.from"
                :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('common.step.form.replay')" prop="replyTo">
          <el-select
              v-model="form.replyTo"
              class="mailselectEl"
              remote
              allow-create
              :placeholder="$t('common.please.input')"
              style="width: 50%"
          >
            <el-option
                v-for="item in userMail_dropDownOptionList"
                :key="item.configId"
                :label="item.from"
                :value="item.configId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('common.step.txt.3')" prop="nickName">
          <el-input
              v-model="form.nickName"
              :placeholder="$t('common.step.nick.name')"
              style="width: 50%"
          ></el-input>
        </el-form-item>
        <el-form-item prop="isCheckCC">
          <template #default>
            <div style="display: flex;flex-direction: column;width: 50%;">
              <el-checkbox
                  v-model="form.isCheckCC"
                  :label="$t('common.add.cc')"
                  size="large"
              />
              <el-select
                  v-if="form.isCheckCC"
                  v-model="form.cc"
                  class="mailselectEl"
                  style="width: 100%;"
                  remote
                  multiple
                  filterable
                  allow-create
                  default-first-option
                  :reserve-keyword="false"
                  :placeholder="$t('common.please.input')"
                  @focus="(event) => handleFocus(event, 'cc')"
              >
              </el-select>
            </div>
          </template>
        </el-form-item>
        <el-form-item prop="isCheckBCC">
          <template #default>
            <div style="display: flex;flex-direction: column;width: 50%;">
              <el-checkbox
                  v-model="form.isCheckBCC"
                  :label="$t('common.add.bcc')"
                  size="large"
              />
              <el-select
                  v-if="form.isCheckBCC"
                  v-model="form.bcc"
                  class="mailselectEl"
                  style="width: 100%;"
                  remote
                  multiple
                  filterable
                  allow-create
                  default-first-option
                  :reserve-keyword="false"
                  :placeholder="$t('common.please.input')"
                  @focus="(event) => handleFocus(event, 'bcc')"
              >
              </el-select>
            </div>
          </template>
        </el-form-item>
        <el-form-item prop="sendTime" v-if="sessionStore.get('STEP_0_SELECT_TYPE')!== 1">
          <template #label>
            <div style="display: flex;justify-content: flex-start;align-items: center">
              <span style="font-weight: 700;color: #606266">{{ $t('common.send.timing') }}</span>
              <span style="margin-left: 35px;">
                <el-checkbox
                    v-model="form.checked1Time"
                    :label="$t('common.step.nick.option1')"
                    size="large"
                    @change="handleSendTypeChange('unifiedTime', $event)"
                />
                <el-checkbox
                    v-model="form.checked2Location"
                    size="large"
                    @change="handleSendTypeChange('localTime', $event)"
                >
                  {{ $t('common.step.nick.option2') }}
                  <span class="recommended-label">{{ $t('common.step.nick.recommended') }}</span>
                </el-checkbox>
              </span>
            </div>
          </template>
          <template #default>
            <div style="display: flex;flex-direction: column" v-if="form.checked1Time">
              <div class="country-timezone">
                <div style="width: 90px;font-weight: 700;color: #606266">{{ $t('common.cds64') }}</div>
                <el-select v-model="form.zoneAddress" :placeholder="$t('common.please.select')"
                           filterable class="select_country"
                           popper-class="sp_country"
                           style="width: 340px;"
                >
                  <el-option
                      v-for="item in areaList"
                      :key="item.country"
                      :label="lang!=='zh-CN'?item.countryEn:item.country"
                      :value="lang!=='zh-CN'?item.countryEn:item.country"
                  />
                </el-select>
                <span v-if="countryTimeZoneLabel" class="country-timezone__label" style="font-size: 14px">
                  {{ countryTimeZoneLabel }}
                </span>
              </div>
              <div style="display: flex;margin-top: 10px;">
                <div style="width: 90px;font-weight: 700;color: #606266">{{ $t('sending.customer.search.startTime.sp') }}</div>
                <div class="schedule-time-field">
                  <el-date-picker
                      v-model="form.sendTime"
                      type="datetime"
                      style="width: 340px;"
                      :class="{'schedule-date-picker--error': isEditStartTimeExpired}"
                      :disabled-date="disabledDate"
                      format="YYYY-MM-DD HH:mm:ss"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      :placeholder="$t('common.please.select')"
                      @change="handleChangeSendTime"
                  >
                  </el-date-picker>
                  <div v-if="isEditStartTimeExpired" class="schedule-start-time__error">
                    {{ $t('common.step.schedule.edit_start_time_expired') }}
                  </div>
                </div>
              </div>
              <div style="display: flex;margin-top: 10px;">
                <div style="width: 90px;font-weight: 700;color: #606266">{{ $t('sending.customer.search.endTime.sp') }}</div>
                <el-date-picker
                    v-model="form.endTime"
                    type="datetime"
                    style="width: 340px;"
                    :disabled-date="disabledEndDate"
                    :disabled-hours="disabledEndHours"
                    :disabled-minutes="disabledEndMinutes"
                    :disabled-seconds="disabledEndSeconds"
                    format="YYYY-MM-DD HH:mm:ss"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    :placeholder="$t('common.please.select')"
                    @change="handleChangeEndTime"
                />
              </div>
            </div>
            <div v-else-if="form.checked2Location" style="display: flex;margin-top: 10px;">
              <div style="display: flex;flex-direction: column;gap: 10px;">
                <div style="display: flex;">
                  <div style="width: 90px;font-weight: 700;color: #606266">{{ $t('sending.customer.search.startTime') }}</div>
                  <div class="schedule-time-field">
                    <el-date-picker
                        v-model="form.sendTime"
                        type="datetime"
                        style="width: 340px;"
                        :class="{'schedule-date-picker--error': isEditStartTimeExpired}"
                        :disabled-date="disabledDate"
                        @change="handleChangeSendTime"
                        format="YYYY-MM-DD HH:mm:ss"
                        value-format="YYYY-MM-DD HH:mm:ss"
                        :placeholder="$t('common.please.select')"
                    />
                    <div v-if="isEditStartTimeExpired" class="schedule-start-time__error">
                      {{ $t('common.step.schedule.edit_start_time_expired') }}
                    </div>
                  </div>
                </div>
                <div style="display: flex;">
                  <div style="width: 90px;font-weight: 700;color: #606266">{{ $t('sending.customer.search.endTime') }}</div>
                  <el-date-picker
                      v-model="form.endTime"
                      type="datetime"
                      style="width: 340px;"
                      :disabled-date="disabledEndDate"
                      :disabled-hours="disabledEndHours"
                      :disabled-minutes="disabledEndMinutes"
                      :disabled-seconds="disabledEndSeconds"
                      format="YYYY-MM-DD HH:mm:ss"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      :placeholder="$t('common.please.select')"
                      @change="handleChangeEndTime"
                  />
                </div>
              </div>
            </div>
          </template>
        </el-form-item>
        <el-form-item>
          <div
              v-if="form.checked1Time || form.checked2Location"
              class="schedule-tip"
          >
            <div class="schedule-summary">
              {{ $t('common.step.schedule.summary', {count: targetCount, duration: estimatedDuration}) }}
            </div>
            <div>{{ $t('common.step.schedule.tip') }}</div>
          </div>
        </el-form-item>
        <el-form-item :label="$t('common.step.remark')" prop="remark">
          <el-input
              v-model="form.remark"
              :placeholder="$t('common.please.input')"
              style="width: 50%"
              :maxlength="30"
              show-word-limit
              clearable
              type="text"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import {computed, onBeforeUnmount, onMounted, reactive, ref, watch} from "vue";
import {i18n} from "@/lang";
import img1 from "@/assets/Marketing/1@2x.png"
import img2 from "@/assets/Marketing/2@2x.png"
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import CountrySelect from "@/components/CountrySelect/index.vue";
import {getMailConfigList} from "@/api";
import {Plus} from "@element-plus/icons-vue";
import {UserTable} from "@/views/Marketing/db_user";
import dayjs from "dayjs";
import sessionStore from "@/utils/sessionStore";
import {isEmpty} from "@/utils/mylodash";

const store = useStore();
const router = useRouter();
const route = useRoute()

const userMail_dropDownOptionList = ref([]);
const configMapSysUser = reactive({});
const configIdMapUserName = reactive({});
const userNameMap = reactive({});
const teamId = computed(() => store.state.email.teamID);
const lang = computed(() => store.state.system.langLocal)
const areaList = computed(() => store.state.customer.areaList);

const props = defineProps({
  currentMassEmailObj: {
    type: Object,
    default: () => ({})
  },
})

const options = [
  {
    value: 1,
    label: i18n.global.t('common.step.txt.select.1'),
  },
  {
    value: 2,
    label: i18n.global.t('common.step.txt.select.2'),
  },
  {
    value: 3,
    label: i18n.global.t('common.step.txt.select.3'),
  },
  {
    value: 4,
    label: i18n.global.t('common.step.txt.select.4'),
  },
  {
    value: 5,
    label: i18n.global.t('common.step.txt.select.5'),
  },
  {
    value: 6,
    label: i18n.global.t('common.step.txt.select.6'),
  },
  {
    value: 7,
    label: i18n.global.t('common.step.txt.select.7'),
  },
  {
    value: 8,
    label: i18n.global.t('common.step.txt.select.8'),
  },
]

// 营销类型默认间隔；产品策略调整时仅修改此处。
const MARKETING_INTERVAL_SECONDS = Object.freeze({
  1: 120,
  2: 60,
})
const SCHEDULE_CONTEXT_STORAGE_KEY = 'STEP_3_SCHEDULE_CONTEXT'
const RESEND_SCHEDULE_INITIALIZED_KEY = 'STEP_3_RESEND_SCHEDULE_INITIALIZED'
const EDIT_START_TIME_GRACE_MINUTES = 3

const getMarketingType = () => Number(sessionStore.get("STEP_0_SELECT_TYPE"))

const generateTaskName = () => {
  const marketingType = getMarketingType()
  const marketingOption = options.find(item => item.value === marketingType)
  if (!marketingOption) return ""

  return `${marketingOption.label}${i18n.global.t('common.task')}${dayjs().format("YYMMDD")}`
}

const isGeneratedTaskName = (taskName) => {
  if (typeof taskName !== 'string' || !taskName) return false

  const taskSuffix = i18n.global.t('common.task')
  return options.some(({label}) => {
    const prefix = `${label}${taskSuffix}`
    return taskName.startsWith(prefix) && /^\d{6}$/.test(taskName.slice(prefix.length))
  })
}

const form = ref({
  taskName: generateTaskName(),
  subjectList: [{content: ""}],
  mailMassConfigDtoList: [],
  nickName: "",
  zoneAddress: "",
  sendTime: "",
  endTime: "",
  remark: "",
  // 回复邮箱
  replyTo: "",
  massSendSecond: 0,
  checked1Time: false,
  checked2Location: false,
  isCheckCC: false,
  isCheckBCC: false,
  to: [],
  cc: [],
  bcc: []
})

const findCountryByName = (countryName) => areaList.value.find((item) => (
  String(item.country || '').trim() === String(countryName || '').trim()
  || String(item.countryEn || '').trim().toLowerCase() === String(countryName || '').trim().toLowerCase()
))

const selectedCountry = computed(() => findCountryByName(form.value.zoneAddress))

const CHINESE_TIME_ZONE_NUMBERS = Object.freeze({
  1: '一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六',
  7: '七', 8: '八', 9: '九', 10: '十', 11: '十一', 12: '十二'
})

const countryTimeZoneLabel = computed(() => {
  const utc = selectedCountry.value?.utc
  const matchedOffset = String(utc || '').match(/^UTC([+-])(\d+(?:\.\d+)?)$/i)
  if (!matchedOffset) return utc || ''

  const [, direction, offset] = matchedOffset
  const offsetLabel = lang.value === 'zh-CN'
    ? CHINESE_TIME_ZONE_NUMBERS[offset] || offset
    : offset
  const timeZoneKey = direction === '+' ? 'common.timezone.east' : 'common.timezone.west'
  return i18n.global.t(timeZoneKey, {offset: offsetLabel, utc})
})

const isResendMode = computed(() => Number(route.query.massOrigin) === 4)
const isEditMode = computed(() => Number(route.query.massOrigin) === 2)
// 暂停后生成的草稿沿用 massOrigin=4，但从列表“编辑”进入时不能重置原定时。
const isTaskEditorMode = computed(() => route.query.editTaskStatus !== undefined)
// “暂停并修改”会切换为重发接口，但仍需保留原任务编辑时的开始时间校验。
const isPausedAndModifyMode = computed(() => route.query.pausedAndModify === '1')
const shouldValidateExistingTaskStartTime = computed(() => (
  isEditMode.value || isPausedAndModifyMode.value
))
const isScheduleEnabled = computed(() => form.value.checked1Time || form.value.checked2Location)
const editStartTimeNow = ref(dayjs())
let editStartTimeTimer = null
const hasAppliedEndTimeStartDefault = ref(false)
const hasFutureExistingEndTime = computed(() => {
  if (!shouldValidateExistingTaskStartTime.value) return false

  const endTime = dayjs(form.value.endTime)
  return endTime.isValid() && editStartTimeNow.value.isBefore(endTime)
})
const isEditStartTimeExpired = computed(() => {
  if (!shouldValidateExistingTaskStartTime.value || !isScheduleEnabled.value) return false
  if (hasFutureExistingEndTime.value) return false

  const startTime = dayjs(form.value.sendTime)
  return startTime.isValid() && startTime.isBefore(
    editStartTimeNow.value.subtract(EDIT_START_TIME_GRACE_MINUTES, 'minute')
  )
})

const resetResendSchedule = () => {
  if (
    !isResendMode.value
    || isTaskEditorMode.value
    || isPausedAndModifyMode.value
    || sessionStore.get(RESEND_SCHEDULE_INITIALIZED_KEY)
  ) {
    return false
  }

  const clickTime = dayjs(sessionStore.get('marketing_time'))
  const startTime = clickTime.isValid() ? clickTime : dayjs()
  form.value.sendTime = startTime.format("YYYY-MM-DD HH:mm:ss")
  form.value.endTime = ""
  sessionStore.set(RESEND_SCHEDULE_INITIALIZED_KEY, true)
  return true
}

const startCache = () => {
  // 2️⃣ 初始化时读取缓存
  // const cache = route.query.taskId ? props.currentMassEmailObj : sessionStore.get("STEP_3_EMAIL_FORM_DATA")
  const cache = sessionStore.get("STEP_3_EMAIL_FORM_DATA")
  console.log(cache, 'cache')
  if (cache) {
    try {
      Object.assign(form.value, cache)
      console.log("✅ 表单数据已从缓存恢复")
    } catch (e) {
      console.warn("⚠️ 缓存格式错误，已忽略", e)
    }
  }

  if (form.value.zoneAddress === 'auto') form.value.zoneAddress = ''
  const didResetResendSchedule = resetResendSchedule()

  const generatedTaskName = generateTaskName()
  if (generatedTaskName && (!form.value.taskName || isGeneratedTaskName(form.value.taskName))) {
    form.value.taskName = generatedTaskName
  }

  return didResetResendSchedule
}

const selectWays = ref(sessionStore.get('STEP_0_SELECT_WAYS'))

const handleChangeSelect = (val) => {
  console.log(val, 'val')
  form.value.replyTo = val;
}

function disabledDate(date) {
  return date.getTime() < Date.now();
}

const rules = ref({
  taskName: [{
    required: true,
    message: i18n.global.t('common.email.contentCannotBeEmpty'),
    trigger: ["blur", "change"]
  }],
  mailMassConfigDtoList: [{
    required: true,
    message: i18n.global.t('common.email.contentCannotBeEmpty'),
    trigger: ["blur", "change"]
  }],
  replyTo: [{
    required: true,
    message: i18n.global.t('common.email.contentCannotBeEmpty'),
    trigger: ["blur", "change"]
  }]
})

const handleSendTypeChange = async (type, checked) => {
  if (!checked) return

  form.value.checked1Time = type === 'unifiedTime'
  form.value.checked2Location = type === 'localTime'
  await refreshSchedule({forceEndTime: true})
}

// 3️⃣ 监听变化自动写入缓存
watch(
    props.currentMassEmailObj,
    async (val) => {
      Object.assign(form.value, val)
      applyEndTimeAsDefaultStartTime()
      await refreshSchedule({forceEndTime: true})
    },
    {deep: true}
)

watch(() => form.value.massSendSecond, (newValue) => {
  if (newValue) {
    console.log(newValue, 'newValue')
  }
})

function initUserMailList() {
  // currentMailId = this.mailConfigId;
  return getMailConfigList({teamId: teamId.value}).then((res) => {
    console.log(res, '获取用户邮箱列表');
    if (res.code === 200) {
      // const mailMassConfigDtoList = res.data.data[0].id
      res.result = res.result || [];
      const arr = [];
      res.result.forEach((item) => {
        configMapSysUser[item.id] = item.sysUserId;
        configIdMapUserName[item.username] = item.id;
        userNameMap[item.id] = item.username;
        arr.push({from: item.username, configId: item.id});
      });
      userMail_dropDownOptionList.value = arr;
    }
  });
}

const handleChangeSendTime = (val) => {
  syncEndTime({forceEndTime: true})
}

const getSafeStartTime = () => {
  const rawTime = form.value.sendTime

  // 如果为空直接用当前时间
  if (!rawTime) {
    return dayjs()
  }

  const d = dayjs(rawTime)

  // 如果是非法日期，用当前时间兜底
  if (!d.isValid()) {
    console.warn('非法日期:', rawTime)
    return dayjs()
  }

  return d
}

const targetCount = ref(0)
const hasTargetData = computed(() => targetCount.value > 0)
const durationSeconds = computed(() => targetCount.value * Number(form.value.massSendSecond || 0))
const selectedScheduleDurationSeconds = computed(() => {
  const startTime = dayjs(form.value.sendTime)
  const endTime = dayjs(form.value.endTime)

  if (!startTime.isValid() || !endTime.isValid() || !endTime.isAfter(startTime)) {
    return null
  }

  return endTime.diff(startTime, 'second')
})
const formatEstimatedDuration = (seconds) => {
  const totalSeconds = Number(seconds)
  if (!Number.isFinite(totalSeconds) || totalSeconds <= 0) {
    return i18n.global.t('common.step.schedule.duration.hours', {hours: 0})
  }

  const totalHours = totalSeconds / 60 / 60
  if (totalHours < 24) {
    const hours = Math.ceil(totalHours * 10) / 10
    return i18n.global.t(
      hours === 1 ? 'common.step.schedule.duration.hour' : 'common.step.schedule.duration.hours',
      {hours}
    )
  }

  const days = Math.ceil((totalHours / 24) * 10) / 10
  return i18n.global.t(
    days === 1 ? 'common.step.schedule.duration.day' : 'common.step.schedule.duration.days',
    {days}
  )
}
const estimatedDuration = computed(() => (
    formatEstimatedDuration(selectedScheduleDurationSeconds.value ?? durationSeconds.value)
))
const hasMarketingInterval = computed(() => Number(form.value.massSendSecond) > 0)
const hasValidScheduleDuration = computed(() => Number.isFinite(durationSeconds.value) && durationSeconds.value >= 0)
const hasValidSchedule = computed(() => (
    hasTargetData.value && hasMarketingInterval.value && hasValidScheduleDuration.value
))
const formatDateTime = (date) => date.format("YYYY-MM-DD HH:mm:ss")
const END_TIME_BUFFER_MINUTES = 0

const applyEndTimeAsDefaultStartTime = () => {
  if (
      hasAppliedEndTimeStartDefault.value
      || !isScheduleEnabled.value
      || !hasFutureExistingEndTime.value
  ) {
    return false
  }

  form.value.sendTime = formatDateTime(dayjs(form.value.endTime))
  hasAppliedEndTimeStartDefault.value = true
  return true
}

const minimumEndTime = computed(() => {
  const startTime = getSafeStartTime()
  return hasValidSchedule.value
    ? startTime.add(durationSeconds.value, 'second').add(END_TIME_BUFFER_MINUTES, 'minute')
    : startTime
})

const updateTargetCount = async () => {
  targetCount.value = (await UserTable.getAll()).length
}

const getScheduleContext = () => ({
  marketingType: getMarketingType() || null,
  massMailType: Number(selectWays.value) || null,
  targetCount: targetCount.value,
})

const hasScheduleContextChanged = (previousContext, currentContext) => (
    previousContext?.marketingType !== currentContext.marketingType
    || previousContext?.massMailType !== currentContext.massMailType
    || previousContext?.targetCount !== currentContext.targetCount
)

const syncEndTime = ({forceEndTime = false, preserveExistingEndTime = false} = {}) => {
  const startTime = getSafeStartTime()
  const formattedStartTime = formatDateTime(startTime)
  form.value.sendTime = formattedStartTime
  if (!hasValidSchedule.value) {
    form.value.endTime = formattedStartTime
    return false
  }

  const earliestEndTime = startTime
    .add(durationSeconds.value, 'second')
    .add(END_TIME_BUFFER_MINUTES, 'minute')
  const currentEndTime = dayjs(form.value.endTime)
  if (
      forceEndTime
      || !currentEndTime.isValid()
      || (!preserveExistingEndTime && currentEndTime.isBefore(earliestEndTime))
  ) {
    form.value.endTime = formatDateTime(earliestEndTime)
  }
  return true
}

const disabledEndDate = (date) => dayjs(date).isBefore(minimumEndTime.value, 'day')

const isMinimumEndDate = (date) => date?.isSame(minimumEndTime.value, 'day')
const disabledEndHours = (role, date) => {
  if (!isMinimumEndDate(date)) return []
  return Array.from({length: minimumEndTime.value.hour()}, (_, hour) => hour)
}
const disabledEndMinutes = (hour, role, date) => {
  if (!isMinimumEndDate(date) || hour !== minimumEndTime.value.hour()) return []
  return Array.from({length: minimumEndTime.value.minute()}, (_, minute) => minute)
}
const disabledEndSeconds = (hour, minute, role, date) => {
  if (
      !isMinimumEndDate(date)
      || hour !== minimumEndTime.value.hour()
      || minute !== minimumEndTime.value.minute()
  ) return []
  return Array.from({length: minimumEndTime.value.second()}, (_, second) => second)
}

const handleChangeEndTime = (value) => {
  if (value && dayjs(value).isBefore(minimumEndTime.value)) {
    form.value.endTime = formatDateTime(minimumEndTime.value)
  }
}

const applyMarketingInterval = () => {
  form.value.massSendSecond = MARKETING_INTERVAL_SECONDS[selectWays.value] || 0
}

const refreshSchedule = async ({forceEndTime = false, preserveExistingEndTime = false} = {}) => {
  selectWays.value = sessionStore.get('STEP_0_SELECT_WAYS')
  applyMarketingInterval()
  await updateTargetCount()
  const currentContext = getScheduleContext()
  const previousContext = sessionStore.get(SCHEDULE_CONTEXT_STORAGE_KEY)
  const scheduleContextChanged = hasScheduleContextChanged(previousContext, currentContext)
  const shouldForceEndTime = forceEndTime || (!preserveExistingEndTime && scheduleContextChanged)
  const ready = syncEndTime({
    forceEndTime: shouldForceEndTime,
    preserveExistingEndTime: preserveExistingEndTime || (
      shouldValidateExistingTaskStartTime.value && !forceEndTime && !scheduleContextChanged
    ),
  })
  sessionStore.set(SCHEDULE_CONTEXT_STORAGE_KEY, currentContext)
  return {
    hasTargetData: hasTargetData.value,
    hasMarketingInterval: hasMarketingInterval.value,
    ready,
  }
}

onMounted(async () => {
  if (shouldValidateExistingTaskStartTime.value) {
    editStartTimeNow.value = dayjs()
    editStartTimeTimer = window.setInterval(() => {
      editStartTimeNow.value = dayjs()
    }, 1000)
  }

  if (!areaList.value.length) {
    await store.dispatch('customer/getAreaNames')
  }
  await initUserMailList();
  const didResetResendSchedule = startCache()
  const didUseEndTimeAsStartTime = applyEndTimeAsDefaultStartTime()
  const preserveExistingEditSchedule = shouldValidateExistingTaskStartTime.value
    && !sessionStore.get(SCHEDULE_CONTEXT_STORAGE_KEY)
    && !didUseEndTimeAsStartTime
  await refreshSchedule({
    forceEndTime: didResetResendSchedule || didUseEndTimeAsStartTime,
    preserveExistingEndTime: preserveExistingEditSchedule,
  })
})

onBeforeUnmount(() => {
  if (editStartTimeTimer) {
    window.clearInterval(editStartTimeTimer)
    editStartTimeTimer = null
  }
})


const removeSubject = (index, item) => {
  console.log(index, item)
  form.value.subjectList.splice(index, 1)
}

const addSubject = () => {
  // if(form.value.subject.length>4){
  //   ElMessage.warning(i18n.global.t('common.subject.form.max'))
  //   return
  // }
  form.value.subjectList.push({content: ""})
}

const activeSelectProp = ref(null);

function handleFocus(event, type) {
  activeSelectProp.value = type;
}

const ruleFormRef = ref(null);
const isValid = ref(false)
const handleSubmitForm = () => {
  return new Promise((resolve) => {
    ruleFormRef.value.validate((valid, fields) => {
      isValid.value = valid && !isEditStartTimeExpired.value
      resolve(isValid.value) // ✅ 验证完成后返回结果
    })
  })
}

defineExpose({
  handleSubmitForm,
  refreshSchedule,
  form,
  isValid,
})
</script>

<style lang="less" scoped>
.content {
  margin: 0px auto;
  height: 100%;
  width: 900px;
  text-align: left;

  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }

  .box_inner {
    padding: 20px;
    margin-top: 10px;
    max-height: calc(100vh - 270px);
    overflow: scroll;
    background: #FAFAFA;
  }
}

.setting_box {
  width: 160px;
  padding-left: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

:deep(.el-form-item) {
  margin-bottom: 16px !important;
}

.demo-ruleForm {
  :deep(.el-form-item__label) {
    color: #606266;
    font-size: 14px;
    font-weight: 700;
  }
}

:deep(.el-checkbox.el-checkbox--large) {
  height: 32px !important;
}

.recommended-label {
  color: #5a9cf8;
}

.country-timezone {
  display: flex;
  align-items: center;

  &__label {
    margin-left: 12px;
    color: #909399;
    font-size: 16px;
    white-space: nowrap;
  }
}

.schedule-tip {
  width: 430px;
  margin-left: 90px;
  color: #d6854e;
  font-size: 14px;
  line-height: 20px;
  white-space: normal;

  .schedule-summary {
    margin-bottom: 4px;
    color: #606266;
  }
}

.schedule-time-field {
  width: 340px;

  :deep(.schedule-date-picker--error .el-input__wrapper) {
    box-shadow: 0 0 0 1px var(--el-color-danger) inset !important;
  }
}

.schedule-start-time__error {
  margin-top: 4px;
  color: var(--el-color-danger);
  font-size: 12px;
  line-height: 18px;
}
</style>
